import { CertificationStatusChipOrIcon } from '@tableau/data-catalog-client-components';
import { LabelAssetType } from '@tableau/data-catalog-shared';
import React from 'react';

import { LabelWrapper } from '~src/catalog/CatalogLabelsHookHelper';
import { CERTIFIED_INDICATOR_TYPE } from '~src/catalog/components/labels/DataQualityType';
import { CatalogTelemetryProvider } from '~src/catalog/DataCatalogTelemetry';
import { dataQualityIndicatorInfoToDataQualityIndicator } from '~src/catalog/models/IDataQualityIndicatorInfo';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

import { Messages } from '../../../codegen/Localize';
import { doesTooltipNotHaveOwnerToDisplay } from '../../../spacesPlatform/components/tooltip/Tooltip';
import { TooltipAnchor } from '../../../spacesPlatform/components/tooltip/TooltipAnchor';
import { PublishedConnectionTooltip } from '../tooltips/PublishedConnectionTooltip';

const CertificationCardStyle: React.CSSProperties = {
  paddingTop: '3px',
  marginLeft: '-9px',
  marginRight: '-3px',
};

export class PublishedConnectionCard extends ContentCard {
  public render() {
    const contentUrl = getContentUrlForItem(this.props.content, this.props.urls);

    const imageUrl = PublishedConnections.getPublishedConnectionIconPath(this.props.content as ISpaceItemDetailInfo<'virtualConnection'>, true);

    const publishedConnection = this.props.content;

    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);
    const certificationsExist = publishedConnection.dataQualityIndicators?.filter(i => i.type === CERTIFIED_INDICATOR_TYPE)[0] ?? null;

    const itemInfo = this.props.content as IContentInfo<Extract<ExplorableItemType, LabelAssetType>>;

    const certificationComponent = certificationsExist ?
    FeatureFlags.labelsInMorePlacesEnabled ?
      <div data-tb-test-id='virtualConnection-card-certification' style={CertificationCardStyle}>
        <LabelWrapper itemInfo={itemInfo} category={'certification'} masthead={false} kind={'icon'}/>
      </div>
      : (<div data-tb-test-id='virtualConnection-card-certification' style={CertificationCardStyle}>
          <CatalogTelemetryProvider>
            <CertificationStatusChipOrIcon
              subjectArea={'VirtualConnection'}
              kind={'vizportal'}
              anchoredAsset={{
                assetName: this.props.content.name,
                assetType: 'VirtualConnection',
                assetUrl: () => contentUrl,
              }}
              anchoredCertifications={[dataQualityIndicatorInfoToDataQualityIndicator(certificationsExist)]}
              iconOnly={true}
              urls={this.props.urls}
              linksDisabled={false}
              source={'PublishedConnectionCard'}
            />
          </CatalogTelemetryProvider>
        </div>
        ) : null;

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.publishedConnectionTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail
            defaultImageUrl={imageUrl}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={contentUrl}
            useBase64EncodedImage={true}
            allowDragAndDrop={this.props.allowDragAndDrop}
            aria-label={this.props.content.name}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          {certificationComponent}
          <span data-tb-test-id="publishedConnection-name" className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            {this.props.content.name}
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'virtualConnection' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'virtualConnection' })}
            />
          </span>
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return (
      <PublishedConnectionTooltip
        content={this.props.content}
        urls={this.props.urls}
        inProjectSpace={this.props.inProjectSpace}
      />
    );
  };
}
